// Entry point for the build script in your package.json
import React from "react"
import { createRoot } from "react-dom/client"
import App from "./components/App"

// Mount React app
const rootEl = document.getElementById("root")
if (rootEl) {
  const root = createRoot(rootEl)
  root.render(React.createElement(App))
}
